export default "__VITE_ASSET__29356b37__"